<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="LIQUIDACIÓN ABIERTA" key="1">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                :modalFieldsSetup="master.modalFieldsSetup"
                @action="masterAction"
                @params="paramsTable"
                modalWidth="90%"
                ref="master"
      >
        <span slot="estadoRenderer" slot-scope="{text}">
          <a-tag :color="text==='LIQ' ? 'blue' : (text === 'CER' ? 'red' : 'red')">{{text}}</a-tag>
        </span>
        <template slot="customButton">
          <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
        </template>
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <template>
            <a-row :gutter="[16,16]">
              <a-tabs defaultActiveKey="1">
                <a-tab-pane key="1" v-if="isvisible">
                  <span slot="tab">
                    <a-icon type="vertical-align-top"/>
                    Información General
                  </span>
                  <a-col v-bind="colOptions">
                    <g-lookup :label="$t('Empleado')"
                              :formItemConfig="fiOptions"
                              endpoint="empleados"
                              :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                    </g-lookup>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Fecha inicio del turno')">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD 00:00:00"
                                     v-decorator="['date_mark_ini', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      ></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Tipo de dia inicio del turno')"
                                :formItemConfig="fiOptions"
                                :decorator="['festive_ini', { rules: [{ required: false}] }]"
                                :params="tipo_dia">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Fecha fin del turno')">
                      <a-date-picker style="width: 100%"
                                     type="date"
                                     valueFormat="Y-MM-DD 00:00:00"
                                     v-decorator="['date_mark_end', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      ></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Tipo de dia fin del turno')"
                                :formItemConfig="fiOptions"
                                :decorator="['festive_end', { rules: [{ required: false}] }]"
                                :params="tipo_dia">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Tipo de turno')"
                                :formItemConfig="fiOptions"
                                endpoint="shift_setup"
                                ref="shift_setup"
                                :decorator="['id_rh_t_shifts_setup', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Clase de turno')">
                      <a-input
                        v-decorator="['mark_class', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Estado')"
                                :formItemConfig="fiOptions"
                                :decorator="['status', { rules: [{ required: false}] }]"
                                :params="estado_liq_turno">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Año de liquidación')" v-bind="fiOptions">
                      <a-select :default-value="yearToday" v-decorator="['year', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                        <a-select-option v-for="year_ in years" :key="year_">
                          {{ year_ }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Mes de liquidación')" v-bind="fiOptions">
                      <a-select v-decorator="['month', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                        <a-select-option v-for="month_ in months_name" :key="month_.value">
                          {{ month_.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown :label="$t('Periodo de liquidación')"
                                :formItemConfig="fiOptions"
                                endpoint="hierarchy_lookup"
                                :decorator="['period', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                                :params="period_request">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Grupo')"
                                :formItemConfig="fiOptions"
                                :decorator="['id_h_att1', { rules: [{ required: false}] }]"
                                :params="grupo"
                                :selectedObj.sync="grupoSeleccionado">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Puesto')"
                                :formItemConfig="fiOptions"
                                :decorator="['id_h_att2', { rules: [{ required: false}] }]"
                                :params="puestoParams"
                                :selectedObj.sync="puestoSeleccionado">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <g-dropdown endpoint="hierarchy_lookup"
                                style="width: 100%"
                                :label="$t('Turno normal o un extra?')"
                                :formItemConfig="fiOptions"
                                :decorator="['type_mark', { rules: [{ required: false}] }]"
                                :params="tipo_mark">
                    </g-dropdown>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Hora Inicio Marcacion')" v-bind="fiOptions">
                      <a-time-picker use12Hours format="hh:mm A" valueFormat="HH:mm"
                                     v-decorator="['start_time', {type:'object', rules: [{ required: false, message: 'Valor requerido' }] }]"
                                     placeholder="H. Inicio"
                                     style="width: 100%"
                      ></a-time-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Hora Fin Marcacion')" v-bind="fiOptions">
                      <a-time-picker use12Hours format="hh:mm A" valueFormat="HH:mm"
                                     v-decorator="['end_time', {type:'object', rules: [{ required: false, message: 'Valor requerido' }] }]"
                                     placeholder="H. Fin"
                                     style="width: 100%"
                      ></a-time-picker>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Horas Salario')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-tab-pane>
                <a-tab-pane key="2">
                  <span slot="tab">
                    <a-icon type="bulb"/>
                    Información de horas extras y recargos
                  </span>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Horas extras diurnas')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours_ext_diur', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Horas extras nocturna')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours_ext_noct', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Horas de recargos nocturnos')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours_rec_noct', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Horas extras diurnas festivas')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours_ext_diur_fest', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Horas extras nocturnas festivas')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours_ext_noct_fest', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item
                      :label="$t('Horas de Recargos Dominicales Diurnos')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours_rec_dominical', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item
                      :label="$t('Horas de Recargos Dominicales Nocturnos')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours_rec_dom_sin_comp', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item
                      :label="$t('Horas de Recargo Diurno Festivo')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours_rec_dom_sin_comp_fest', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Horas de Recargo Nocturno Festivo')">
                      <a-input-number v-bind="fiOptions" style="width: 100%"
                                      v-decorator="['hours_rec_noct_esp', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptions">
                    <a-form-item :label="$t('Origen')">
                      <a-input
                        v-decorator="['origen', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col v-bind="colOptionsObs">
                    <a-form-item v-bind="fiOptions" :label="$t('Observaciones')">
                      <a-textarea auto-size
                                  v-decorator="['observations', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-tab-pane>
              </a-tabs>
            </a-row>
          </template>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="DETALLE MARCACION" key="2">
          <overtime-details v-if="id_emp" :id_emp="id_emp" :fecha_ini="fecha_ini_turno"></overtime-details>
          <span v-else>Dar clic en el icono <a-icon type="search"/> para ver el detalle las marcaciones.</span>
        </a-tab-pane>
      </a-tabs>
    </a-tab-pane>
    <a-tab-pane tab="LIQUIDACIÓN CERRADA" key="2">
      <overtime-liq-cer></overtime-liq-cer>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  export default {
    data () {
      return {
        isvisible: false,
        registroSeleccionado: {},
        grupoSeleccionado: {},
        puestoSeleccionado: {},
        fileNameExcel: 'turnos_a_liquidar',
        paramsT: {},
        endpointExcel: 'overtime_liq_/downloadExcel',
        tipo_dia: {
          h_lookup_type: 'TIPO_DIA_MARCACION',
          use_code: true
        },
        grupo: {
          h_lookup_type: 'ID_H_ATT1'
        },
        tipo_mark: {
          h_lookup_type: 'OVERTIME_LIQ_TYPE_MARK',
          use_code: true
        },
        estado_liq_turno: {
          h_lookup_type: 'ESTADO_LIQ_TURNO',
          use_code: true
        },
        period_request: {
          h_lookup_type: 'PERIODOS_LIQUIDACION',
          use_code: true
        },
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        colOptions: {xs: 24, sm: 6},
        colOptions1: {xs: 24, sm: 12},
        colOptionsObs: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        master: {
          endpoint: 'overtime_liq',
          tableSetup: {
            selectedRows: [],
            customSlots: ['estadoRenderer', 'expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            actions: {
              actions: [
                {
                  name: 'detalles',
                  text: 'Detalles',
                  icon: 'search',
                  props: {size: 'small', type: 'link', icon: 'search', style: 'color:green;'}
                },
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                }
              ]
            },
            columns: [
              {title: this.$t('ID empleado'), dataIndex: 'id_emp', sorter: true},
              {title: this.$t('Nombre del empleado'), dataIndex: 'nombre_empleado', sorter: true},
              {
                title: this.$t('Fecha Ini. Turno'),
                dataIndex: 'date_mark_ini',
                sorter: true,
                scopedSlots: {filterDropdown: 'dateBetweenFilter'}
              },
              {title: this.$t('Tipo Dia Ini.'), dataIndex: 'fecha_ini_es_festivo', sorter: true},
              {
                title: this.$t('Fecha Fin Turno'),
                dataIndex: 'date_mark_end',
                sorter: true,
                scopedSlots: {filterDropdown: 'dateBetweenFilter'}
              },
              {title: this.$t('Tipo Dia Fin.'), dataIndex: 'fecha_fin_es_festivo', sorter: true},
              {title: this.$t('Turno'), dataIndex: 'tipo_marcacion', sorter: true},
              {title: this.$t('Clase de Turno'), dataIndex: 'mark_class', sorter: true},
              {title: this.$t('Tipo de Turno'), dataIndex: 'type_mark', sorter: true},
              {title: this.$t('Grupo'), dataIndex: 'grupo', sorter: true},
              {title: this.$t('Puesto'), dataIndex: 'puesto', sorter: true},
              {title: this.$t('Año'), dataIndex: 'year', sorter: true},
              {title: this.$t('Mes'), dataIndex: 'month', sorter: true},
              {title: this.$t('Periodo'), dataIndex: 'period', sorter: true},
              {title: this.$t('Hora Ini. Marcacion'), dataIndex: 'start_time', sorter: true},
              {title: this.$t('Hora Fin Marcacion'), dataIndex: 'end_time', sorter: true},
              {title: this.$t('Horas Salario'), dataIndex: 'hours', sorter: true},
              {title: this.$t('Observaciones'), dataIndex: 'observations', sorter: true},
              {title: this.$t('Hrs. Extras Diurnas'), dataIndex: 'hours_ext_diur', sorter: true},
              {title: this.$t('Hrs. Extras Nocturna'), dataIndex: 'hours_ext_noct', sorter: true},
              {title: this.$t('Rec. Nocturno'), dataIndex: 'hours_rec_noct', sorter: true},
              {title: this.$t('Hrs. Extras Diurnas Festivas'), dataIndex: 'hours_ext_diur_fest', sorter: true},
              {title: this.$t('Hrs. Extras Nocturnas Festivas'), dataIndex: 'hours_ext_noct_fest', sorter: true},
              {title: this.$t('Rec. Diurno Dominical'), dataIndex: 'hours_rec_dominical', sorter: true},
              {title: this.$t('Rec. Nocturno Dominical'), dataIndex: 'hours_rec_dom_sin_comp', sorter: true},
              {title: this.$t('Rec. Diurno Festivo'), dataIndex: 'hours_rec_dom_sin_comp_fest', sorter: true},
              {title: this.$t('Rec. Nocturno Festivo'), dataIndex: 'hours_rec_noct_esp', sorter: true},
              {title: this.$t('Origen'), dataIndex: 'origen', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'hours_ext_diur'},
            {name: 'hours_ext_noct'},
            {name: 'hours_rec_noct'},
            {name: 'hours_rec_noct_esp'},
            {name: 'hours_ext_diur_fest'},
            {name: 'hours_ext_noct_fest'},
            {name: 'hours_rec_dominical'},
            {name: 'hours_rec_dom_sin_comp'},
            {name: 'hours_rec_dom_sin_comp_fest'},
            {name: 'start_time'},
            {name: 'end_time'},
            {name: 'hours'},
            {name: 'observations'},
            {name: 'origen'}
          ],
          valoresExpandidos: [
            {label: this.$t('Hora Ini. Marcacion'), column: 'start_time'},
            {label: this.$t('Hora Fin Marcacion'), column: 'end_time'},
            {label: this.$t('Horas Salario'), column: 'hours'},
            {label: this.$t('Hrs. Extras Diurnas'), column: 'hours_ext_diur'},
            {label: this.$t('Hrs. Extras Nocturna'), column: 'hours_ext_noct'},
            {label: this.$t('Rec. Nocturno'), column: 'hours_rec_noct'},
            {label: this.$t('Hrs. Extras Diurnas Festivas'), column: 'hours_ext_diur_fest'},
            {label: this.$t('Hrs. Extras Nocturnas Festivas'), column: 'hours_ext_noct_fest'},
            {label: this.$t('Rec. Diurno Dominical'), column: 'hours_rec_dominical'},
            {label: this.$t('Rec. Nocturno Dominical'), column: 'hours_rec_dom_sin_comp'},
            {label: this.$t('Rec. Diurno Festivo'), column: 'hours_rec_dom_sin_comp_fest'},
            {label: this.$t('Rec. Nocturno Festivo'), column: 'hours_rec_noct_esp'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {filter_parent_overtime_liq: true}
      },
      paramsExcel () {
        return {...this.paramsT, ...this.parentData, columns: this.master.tableSetup.columns}
      },
      overtimeLiqInfo () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      puestoParams () {
        return {
          h_lookup_type: 'ID_H_ATT2',
          id_h_lookup_father: this.grupoSeleccionado.value ? this.grupoSeleccionado.value : this.puestoSeleccionado.value
        }
      },
      id_emp () {
        return this.registroSeleccionado.id_emp
      },
      fecha_ini_turno () {
        return this.registroSeleccionado.date_mark_ini
      }
    },
    mounted () {
      this.yearsSelect()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.isvisible = true
            break
          case 'masterEdit':
            this.isvisible = false
            break
          case 'detalles':
            this.registroSeleccionado = action.record
            break
        }
      },
      yearsSelect () {
        for (let i = 2020; i <= (this.yearToday + 6); i++) {
          this.years.push(i)
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/OvertimeTurn/OvertimeLiq.vue